import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "nav" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Tim Aro Photography", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Portfolio")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Stories")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("About")
const _hoisted_6 = { class: "hamburgerContainer" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "bar1" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "bar2" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "bar3" }, null, -1)
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  class: "burgerMenu",
  id: "burgerBox"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Stories")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("About")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createVNode(_component_router_link, {
      class: "navTitle",
      to: "/"
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      class: "navItem",
      to: "/"
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      class: "navItem",
      to: "/projects"
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      class: "navItem",
      to: "/about"
    }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", {
        class: _normalizeClass(["container", {active: _ctx.isActive}]),
        id: "burgerBtn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.burger(this)))
      }, _hoisted_10, 2),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_router_link, {
          class: "navItemMobile",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.burger(this))),
          to: "/"
        }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "navItemMobile",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.burger(this))),
          to: "/projects"
        }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "navItemMobile",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.burger(this))),
          to: "/about"
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        })
      ])
    ])
  ]))
}